import React, { useEffect, useState } from "react";
import { Button, Card, CardBody, CardHeader, Col, Container, Row, Spinner, Input } from "reactstrap";
import BreadCrumb from "../../../Components/Common/BreadCrumb";
import { useNavigate, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { getAuthUser } from "../../../helpers/utils";
import { useDispatch, useSelector } from "react-redux";
import { fetchQuestionHintsTableColumnNames, fetchAllQuestionHints, createQuestionHints, updateQuestionHints, 
    deleteQuestionHints, updateUserPreference} from "../../../slices/thunks";
import ColumnSelectionModal from "../../../Components/Common/ColumnSelectionModal/ColumnSelectionModal";
import CommonTable from "../../../Components/Common/Table/CommonTable";
import DeleteModal from "../../../Components/Common/DeleteModal";
import AddModal from "../../../Components/Common/Modal/AddModal";
import AddCommonForm2 from "../../../Components/Common/AddCommonForm/AddCommonForm2";


const labels = [
  {
    id: 1,
    labelName: "HintEn",
    fieldName: "editor",
    name: "HintEn",
    value: "HintEn",
    required: true,
  },
  {
    id: 2,
    labelName: "HintAr",
    fieldName: "editor",
    name: "HintAr",
    value: "HintAr",
    required: true,
  },
  {
    id: 3,
    labelName: "Complete Solution",
    fieldName: "check-box",
    name: "IsCompleteSolution",
    value: "IsCompleteSolution",
    required: false,
  }
]


function QuestionHints ( { questionId, marginTop = 0}) {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { t, i18n } = useTranslation();
  const user = getAuthUser();
  const [show, setShow] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [isAddOrEdit, setIsAddOrEdit] = useState("isAdd");
  const [selectedRow, setSelectedRow] = useState({});
  const [selectedIds, setSelectedIds] = useState([]);
  const [deleteModal, setDeleteModal] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedColumns, setSelectedColumns] = useState([]);

  const { Course, QuestionHints, tableColumnNames, loading, headerLoad, module } = useSelector((state) => ({
    QuestionHints: state.QuestionHints.questionHints,
    tableColumnNames: state.QuestionHints.tableColumnNames,
    loading: state.QuestionHints.loading,
    headerLoad: state.QuestionHints.headerLoad,
    module: state.Module.module,
}));

  // Compute permission
  const permission = (() => {
    const moduleItem = module?.find(
        (m) => m.moduleId === 9 && m.modulePermission?.CanView
      );
      const pageItem = moduleItem?.pages?.find((p) => p.pageId === 8); // Roles Management = pageId: 2
      
      if (moduleItem && pageItem) {
          return {
              CanView:
              moduleItem.modulePermission.CanView && pageItem.permissions.CanView,
              CanAdd:
              moduleItem.modulePermission.CanAdd && pageItem.permissions.CanAdd,
              CanEdit:
        moduleItem.modulePermission.CanEdit && pageItem.permissions.CanEdit,
        CanDelete:
        moduleItem.modulePermission.CanDelete &&
        pageItem.permissions.CanDelete,
        CanActive:
        moduleItem.modulePermission.CanActive &&
        pageItem.permissions.CanActive,
      };
    }
    
    return {};
})();



  const onAddClickHandler = (value) => {
    setShow(true);
    setIsAddOrEdit(value);
    setSelectedRow({});
  };

  const onEditClickHandler = (questionHints, value) => {
    setSelectedRow(questionHints);
    setIsAddOrEdit(value);
    setShow(true);
  };
  
  const onChangeHandler = (e) => {
    const { name, value } = e.target;
    if (name == 'IsCompleteSolution') {    
      setSelectedRow((prev) => ({
        ...prev,
        [name]: e.target.checked
      }));
    }else{
      setSelectedRow((prev) => ({
        ...prev,
        [name]: value
      }));
    }
  };
  
  
  const onSubmitHandler = (e) => {
    e.preventDefault();


    const questionHintsObj = {
      HintEn: selectedRow.HintEn,
      HintAr: selectedRow.HintAr,
      QuestionID: questionId,
      IsCompleteSolution: selectedRow.IsCompleteSolution || false
    };

    if (isAddOrEdit === "isEdit") {
        questionHintsObj.ID = selectedRow?.ID;
    }

    isAddOrEdit === "isAdd" ?
      dispatch(createQuestionHints(questionHintsObj)) :
      dispatch(updateQuestionHints(questionHintsObj));

    setShow(false);
  };

  const handleSave = async () => {
    const preferencesPayload = {
      UserId: user.UserId,
      ColumnIDs: tableColumnNames.reduce((acc, column) => {
        acc[column.ColumnId] = selectedColumns.includes(column.ColumnId);
        return acc;
      }, {}),
    };

    try {
      await dispatch(updateUserPreference(preferencesPayload)).unwrap();
      await dispatch(
        fetchAllQuestionHints({
          module: "QUESTIONHINTS"
        })
      );

      setModalOpen(false);
    } catch (error) {
      console.error("Error updating preferences:", error);
    }
  };

  const confirmDelete = () => {
    dispatch(deleteQuestionHints({ Ids: selectedIds, UserId: user.UserId }))
      .then(() => {
        setSelectedIds([]);
      })
      .catch((error) => {
        console.error("Error deleting:", error);
      });
    setDeleteModal(false);
  };
  
  useEffect(() => {
    dispatch(fetchQuestionHintsTableColumnNames({ module: "QUESTIONHINTS" }))
    dispatch(fetchAllQuestionHints({QuestionId:questionId}));

  }, [dispatch]);

  return (
    <div className="page-content" style={{ marginTop: marginTop }}>
      <Container fluid>
        <Row className="mb-3">
          <Col>
            <BreadCrumb title={t('QuestionHints')} />
          </Col>
        </Row>
        <div className="table-responsive">
          <Card>
            <CardBody>
              <div className="listjs-table" id="customerList">
                <Row className="g-4 mb-3">
                  <Col className="col-sm-auto">
                    <div>
                      <Button
                        className="btn btn-soft-danger ms-2 me-2"
                        onClick={() => setDeleteModal(true)}
                        disabled={selectedIds.length === 0}
                      >
                        <i className="ri-delete-bin-2-line"></i>
                      </Button>
                      {permission.CanAdd && (
                        <Button
                          color="secondary"
                          className="add-btn me-1"
                          onClick={() => onAddClickHandler("isAdd")}
                          id="create-btn"
                        >
                          <i className="ri-add-line align-bottom me-1 ms-1"></i>
                          {t("AddNew")}
                        </Button>
                      )}
                    </div>
                  </Col>
                  <Col className="col-sm">
                    <div className="d-flex justify-content-sm-end">
                      <Button
                        className="btn btn-soft"
                        onClick={() => setModalOpen(true)}
                      >
                        <i className="ri-filter-3-line"></i>
                      </Button>
                      <div className="search-box ms-2 me-2">
                        <Input
                          type="text"
                          className="form-control search"
                          placeholder={t("Search")}
                          value={searchTerm}
                          onChange={(e) => setSearchTerm(e.target.value)}
                        />
                        <i className="ri-search-line search-icon"></i>
                      </div>
                    </div>
                  </Col>
                </Row>
                {loading || headerLoad ? (
                  <div className="d-flex justify-content-center align-items-center">
                  <Spinner style={{ height: "3rem", width: "3rem" }} className="me-2">
                    Loading...
                  </Spinner>
                  </div>
                ) : (
                  <div className="listjs-table" id="customerList">
                    <CommonTable
                      data={QuestionHints}
                      tableColumnNames={tableColumnNames}
                      searchTerm={searchTerm}
                      onEditClickHandler={onEditClickHandler}
                      setDeleteModal={setDeleteModal}
                      setSelectedIds={setSelectedIds}
                      hasAction={true}
                      permission={permission}
                    />
                  </div>
                )}
              </div>
            </CardBody>
          </Card>
        </div>
      </Container>

      {/* Modal  */}
      <AddModal
        show={show}
        setShow={setShow}
        onSubmitHandler={onSubmitHandler}
        title={isAddOrEdit === "isAdd" ? t("AddNewQuestionHints") : t("EditQuestionHints")}
        modalBody={
          <AddCommonForm2
            labels={labels}
            isAddOrEdit={isAddOrEdit}
            selectedRow={selectedRow}
            setSelectedRow={setSelectedRow}
            onChangeHandler={onChangeHandler}
          />
        }
      />

      {/* ColumnSelectionModal */}
      <ColumnSelectionModal
        isOpen={modalOpen}
        toggle={() => setModalOpen(!modalOpen)}
        columns={tableColumnNames}
        selectedColumns={selectedColumns}
        setSelectedColumns={setSelectedColumns}
        handleSave={handleSave}
      />

      {/* Delete modal  */}
      <DeleteModal
        showDelete={deleteModal}
        setShowDelete={setDeleteModal}
        onDeleteClick={confirmDelete}
        setSelectedIds={setSelectedIds}
        description={
          selectedIds.length > 1
            ? `Are you sure you want to delete ${selectedIds.length} selected items?`
            : `Are you sure you want to delete this record?`
        }
      />
    </div>
  );
}

export default QuestionHints;